<template>
    <section class="carrinho">
        <section class="main-carrinho pedido-realizado" :style="{ backgroundImage: 'url(' + $Url + bg_imagem + ')', height: '600px' }">

            <div class="container">
                <div class="row">
                    <div class="col-md-8 col-lg-8">
                        <h2 style="color:#ffffff;">{{ ListaTextos[0].nome }}</h2>
                        <div class="content">
                            <p v-html="ListaTextos[0].resumo1" style="color:#ffffff;font-size:40px;"></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>

</template>

<script>
    import { VMoney } from 'v-money'

    export default {
        components: {
        },
        directives: { money: VMoney },
        data() {
            return {
                bg_imagem: '',
                ListaTextos: [],
                Pedido: [],
                PedidoItem: [],
                PedidoItemAdicional: [],
                PedidoItemManual: [],
                Horarios: {},
                PedidoAgendamento: [],
                PedidoEndereco: [],
                Contato: {
                    NomeEmpresa: "",
                    Assunto: "",
                    Destinatario: "",
                    EmailResposta: "",
                    TextoEmail: "",
                    Anexo: "",
                    NomeAnexo: "",
                    TipoAnexo: "",
                },
                 Contato2: {
                    NomeEmpresa: "",
                    Assunto: "",
                    Destinatario: "",
                    EmailResposta: "",
                    TextoEmail: "",
                    Anexo: "",
                    NomeAnexo: "",
                    TipoAnexo: "",
                },
                Cupons: [],
            }
        },
        methods: {
            CarregaPedido() {
                let dadosArmazenados = localStorage.getItem(this.$UsuarioDados);
                dadosArmazenados = JSON.parse(dadosArmazenados);

                var dadosPedido = "<strong>Dados Cadastro</strong> <br><br>";
                dadosPedido += "Nome: " + dadosArmazenados.agenda[0].nome + "<br>";
                dadosPedido += "Telefone: " + dadosArmazenados.agenda[0].telefone + "<br>";
                dadosPedido += "E-mail: " + dadosArmazenados.agenda[0].email + "<br>";
                dadosPedido += "Responsável: " + dadosArmazenados.agenda[0].responsavel + "<br>";
                dadosPedido += "CNPJ: " + dadosArmazenados.agenda[0].cnpj + "<br>";
                dadosPedido += "Endereço: " + dadosArmazenados.agenda[0].endereco + "<br>";
                dadosPedido += "Numero: " + dadosArmazenados.agenda[0].numero + "<br>";
                dadosPedido += "Complemento: " + dadosArmazenados.agenda[0].complemento + "<br>";
                dadosPedido += "CEP: " + dadosArmazenados.agenda[0].cep + "<br>";
                dadosPedido += "Cidade: " + dadosArmazenados.agenda[0].cidade + "<br>";
                dadosPedido += "Bairro: " + dadosArmazenados.agenda[0].bairro + "<br>";
                dadosPedido += "Estado: " + dadosArmazenados.agenda[0].estado ;
                
                dadosPedido += " <br><br> <strong>Dados Produtos</strong> <br><br>" ;
                dadosArmazenados.produtos.forEach((itemex) => {
                    dadosPedido += "Produto Id: " + itemex.produto.referencia + "<br>"
                    dadosPedido += "Nome: " + itemex.produto.nomeProduto + "<br>"
                    dadosPedido += "Detalhes: " + itemex.detalhes + "<br><br><hr>"
                });
    
                this.Contato.NomeEmpresa = "Inpel Transmissões Mecânicas"
                this.Contato.Assunto = "Solicitação de Orçamento Realizado no Site Inpel - Nome: " + dadosArmazenados.agenda[0].nome
                this.Contato.Destinatario = this.ListaTextos[0].referencia
                this.Contato.EmailResposta = dadosArmazenados.agenda[0].email
                this.Contato.TextoEmail = dadosPedido
                this.Contato.Anexo = ""
                this.Contato.NomeAnexo = ""
                this.Contato.TipoAnexo = "";

                this.EnviaEmail();

                this.Contato2.NomeEmpresa = "Inpel Transmissões Mecânicas"
                this.Contato2.Assunto = "Solicitação de Orçamento Realizado no Site Inpel"
                this.Contato2.Destinatario = dadosArmazenados.agenda[0].email
                this.Contato2.EmailResposta = this.ListaTextos[0].referencia;
                this.Contato2.TextoEmail = dadosPedido + "<br><br> Seu pedido de orçamento foi enviado com sucesso! Em breve entraremos em contato!<br><br>" + 
                "<div dir='ltr' data-smartmail='gmail_signature'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div dir='ltr'><div style='font-family:&quot;times new roman&quot;,&quot;new york&quot;,times,serif'><table border='0' cellspacing='8' cellpadding='0' width='100%' style='color:rgb(0,0,0);font-size:12pt;font-family:arial,helvetica,clean,sans-serif;width:1383px'><tbody><tr><td valign='top' width='1' style='padding:0cm;width:0.75pt'><p style='margin:0px'><img src='https://ci3.googleusercontent.com/mail-sig/AIorK4xXSaKts2Y1zwcJE3EXsgtm0_fJjJVWTeHoPJNc8nzpH-fQxeLdCHiZeKN1CfXnYn5AYs0y98c' class='CToWUd' data-bit='iit'><br></p></td><td valign='top' style='border-width:medium medium medium 1.5pt;border-style:none none none solid;border-color:initial;padding:0cm 0cm 0cm 9pt'><p style='margin:0px'><span style='color:rgb(51,51,51)'><font face='trebuchet ms, sans-serif' size='4'><b>Equipe Inpel</b></font><br></span><span style='font-size:12pt;font-family:Calibri;font-weight:bold'><font color='#666666'><font size='2'></font></font></span><font size='2' style='font-size:12pt'><font color='#666666'><span style='font-family:Calibri'><span style='background-color:rgb(255,255,255)'></span></span><font style='font-family:Calibri'><b>Telefone:</b>&nbsp;+55 51 3034.3000&nbsp;</font></font><font style='color:rgb(51,51,51);font-family:Calibri'>&nbsp;&nbsp;</font></font><font style='font-size:12pt;color:rgb(51,51,51);font-family:Calibri'>&nbsp;</font><span style='font-size:9pt;color:rgb(51,51,51);font-family:Calibri'>&nbsp;&nbsp;</span></p><p style='margin:0px;font-size:12pt'><span style='color:darkblue;background-color:rgb(248,251,253)'><span><a href='https://www.instagram.com/inpel_transmissoesmecanicas' style='color:rgb(17,85,204);font-family:Calibri;font-size:12px' target='_blank' data-saferedirecturl='https://www.google.com/url?q=https://www.instagram.com/inpel_transmissoesmecanicas&amp;source=gmail&amp;ust=1677280743116000&amp;usg=AOvVaw2KZ80oF7_zV4G1AImEX6EU'><img src='https://ci4.googleusercontent.com/proxy/8cTC-LPLINGwAXw6_FA8oxUqF8mKzKaIJvGkgefniyGLuirDT8qzMLT_2ZMYOe7JGPNM_rwMev-tsjoWLp7NYlRg0WLxcjAqtwKPtMBLQ1tVgJlV6DeT6eM9c3Uu1wuVyvQl=s0-d-e1-ft#https://drive.google.com/uc?id=1tXdt1d2at9dY3gHwlTHClFrwXhCuRYBn&amp;export=download' class='CToWUd' data-bit='iit'></a></span></span><span style='background-color:rgb(248,251,253);color:rgb(51,51,51);font-family:Calibri;font-size:12px'>&nbsp;</span><span style='color:darkblue;background-color:rgb(248,251,253)'><span><a href='http://www.facebook.com/inpeltransmissoes' style='color:rgb(17,85,204);font-family:Calibri;font-size:12px' target='_blank' data-saferedirecturl='https://www.google.com/url?q=http://www.facebook.com/inpeltransmissoes&amp;source=gmail&amp;ust=1677280743116000&amp;usg=AOvVaw0VoTIa2Eo4JuhBgzvAdIIV'><img src='https://ci4.googleusercontent.com/proxy/e0a5aONwE5oBkpElLnMYhX4_lFO10CYF4FBrhmG1JcDMheZXFIyWnpcJMp9E7TWrvd1xVcm5gTN3dV7pUtz-wR0zLzPAm2fFJ1-MhRpVDiHZluKNLtK0voG4B4aHrzIDgqcz=s0-d-e1-ft#https://drive.google.com/uc?id=1lT6NmFB3wDUYoh5Gi5qXXGna4EPaD43g&amp;export=download' class='CToWUd' data-bit='iit'></a></span></span><span style='background-color:rgb(248,251,253);color:rgb(51,51,51);font-family:Calibri;font-size:12px'>&nbsp;</span><span style='color:darkblue;background-color:rgb(248,251,253)'><span><a href='https://www.linkedin.com/company/inpeltransmissoesmecanicas' style='color:rgb(17,85,204);font-family:Calibri;font-size:12px' target='_blank' data-saferedirecturl='https://www.google.com/url?q=https://www.linkedin.com/company/inpeltransmissoesmecanicas&amp;source=gmail&amp;ust=1677280743117000&amp;usg=AOvVaw2SY6K2UyXNAQlYcPTw0Rx6'><img src='https://ci4.googleusercontent.com/proxy/4RXxY3hHkwYm8zykZsV6KPucuYlTDlmeSAbcu5R1s1brWfJBPuXmztnAjgdYkDA02U5HKQ8gHnGpe5ryld9HxhQzxrBxRG70nZJeEyO--H1zXIkJWkeQRPArIgfv1Q0oJXOq=s0-d-e1-ft#https://drive.google.com/uc?id=1t5C6VYTbtk6d78XtPyJkQBR-vCHgKQeG&amp;export=download' class='CToWUd' data-bit='iit'></a></span></span><span style='color:darkblue;background-color:rgb(248,251,253)'><span><a href='https://www.inpel.com.br/' style='color:rgb(17,85,204);font-family:Calibri;font-size:12px' target='_blank' data-saferedirecturl='https://www.google.com/url?q=https://www.inpel.com.br/&amp;source=gmail&amp;ust=1677280743117000&amp;usg=AOvVaw2gpVJPc3xUdg-D70z-PJf5'><img src='https://ci6.googleusercontent.com/proxy/hZo0CXmhrp4llU4iODoI7DMOxsuvfhudgvuX4Wt4O3LYDJft-IFt8Rgd6LF0QuZBGmhx-bZomrJMbL5CvJOluNTYlGrX87Tosr0X80bqPAS1VkJshzDuhJjqeTwl0vl5hRMY=s0-d-e1-ft#https://drive.google.com/uc?id=1e1x2dhP1fN2Dg4ScrNHcZzAuvDfIioMS&amp;export=download' class='CToWUd' data-bit='iit'></a></span></span><span style='background-color:rgb(248,251,253)'>&nbsp;</span></p></td></tr></tbody></table><font size='4'><i style='color:rgb(0,0,0)'>&nbsp;</i><b> <font color='#666666'>Qualidade que gera confiança desde 1955.</font></b></font></div><div style='color:rgb(0,0,0);font-family:&quot;times new roman&quot;,&quot;new york&quot;,times,serif;font-size:12pt'><span style='font-size:12pt;color:rgb(153,153,153);font-family:Calibri'>&nbsp; &nbsp;</span><br></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div>";
                this.Contato2.Anexo = "";
                this.Contato2.NomeAnexo = "";
                this.Contato2.TipoAnexo = "";

                this.EnviaEmail2();
                localStorage.removeItem(this.$UsuarioDados);
                                
            },
            EnviaEmail() {
                //var arquivos = document.getElementById("arquivo").files;
                //SE TIVER ANEXO:
                //if (arquivos != null && arquivos.length > 0) {
                //    var arq = "";
                //    var reader = new FileReader();
                //    var arquivoAnexo = arquivos[arquivos.length - 1];
                //    reader.readAsDataURL(arquivoAnexo);
                //    reader.onload = () => {
                //        arq = reader.result;
                //        this.Contato.Anexo = arq.toString().split(",")[1];
                //        this.Contato.NomeAnexo = arquivoAnexo.name;
                //        this.Contato.TipoAnexo = arquivoAnexo.type;
                //        this.$http
                //            .post(this.$apiUrl + "/contato/enviamail", this.Contato)
                //            .then(
                //                (response) => {
                //                    if (response.ok) alert("Enviado");
                //                },
                //                (error) => {
                //                    alert(error.bodyText);
                //                }
                //            );
                //    };
                //}
                //else {
                //SE NAO TIVER ANEXO:
                this.$http.post(this.$apiUrl + "/contato/enviamail", this.Contato)
                    .then(response => {
                        if (response.ok)
                            console.log("Enviado");
                    }, error => {
                        console.log("erro email 1")
                        console.log(error.bodyText)
                    });
                //}
            },
            EnviaEmail2() {
                //var arquivos = document.getElementById("arquivo").files;
                //SE TIVER ANEXO:
                //if (arquivos != null && arquivos.length > 0) {
                //    var arq = "";
                //    var reader = new FileReader();
                //    var arquivoAnexo = arquivos[arquivos.length - 1];
                //    reader.readAsDataURL(arquivoAnexo);
                //    reader.onload = () => {
                //        arq = reader.result;
                //        this.Contato.Anexo = arq.toString().split(",")[1];
                //        this.Contato.NomeAnexo = arquivoAnexo.name;
                //        this.Contato.TipoAnexo = arquivoAnexo.type;
                //        this.$http
                //            .post(this.$apiUrl + "/contato/enviamail", this.Contato)
                //            .then(
                //                (response) => {
                //                    if (response.ok) alert("Enviado");
                //                },
                //                (error) => {
                //                    alert(error.bodyText);
                //                }
                //            );
                //    };
                //}
                //else {
                //SE NAO TIVER ANEXO:
                this.$http.post(this.$apiUrl + "/contato/enviamail", this.Contato2)
                    .then(response => {
                        if (response.ok)
                            console.log("Enviado");
                    }, error => {
                        console.log("erro email 2")
                        console.log(error.bodyText)
                        
                    });
                //}
            },
        },
        created() {
            let dadosArmazenados = localStorage.getItem(this.$UsuarioDados);
            dadosArmazenados = JSON.parse(dadosArmazenados);
            if (dadosArmazenados) {
                if (dadosArmazenados.agenda != '') {
                        this.$http
                            .get(this.$apiUrl + "/institucional/telas/textofinalizado")
                            .then((res2) => res2.json())
                            .then((tiu2) => {
                                this.ListaTextos = tiu2;
                                if (this.ListaTextos[0].institucionalImg != ''){
                                    this.bg_imagem = this.ListaTextos[0].institucionalImg[0].urlImagem;
                                }
                                console.log(this.ListaTextos)
                                this.CarregaPedido();
                            });
                 
                }
                else {
                    this.$redirect("/");
                }
            } else {
                this.$redirect("/");
            }
        }
    }

</script>

<style scoped>

    @import '/css_cart/carrinho.css';
    @import '/css_cart/nova_conta.css';
    @import '/css_cart/pedido_realizado.css';
</style>